import makeRequest from './client';

// API function to fetch CBER & CDER Peds Review data with optional filters and pagination
export const getPedsReviewData = async (
  pageSize: number,
  pageNo: number,
  center?: string,
  appl_num?: string
) => {
  const params = new URLSearchParams();

  // Calculate offset from page number (offset = (page - 1) * pageSize)
  const offset = (pageNo - 1) * pageSize;

  // Add pagination parameters
  params.append('offset', offset.toString());
  params.append('limit', pageSize.toString());

  // Only add center if it's provided and not 'all'
  if (center && center.trim() !== 'all') {
    params.append('center', center.trim());
  }

  // Only add appl_num if it's provided and not empty
  if (appl_num && appl_num.trim()) {
    params.append('appl_num', appl_num.trim());
  }

  const queryString = params.toString();
  const url = `/peds-admin/all?${queryString}`;
  return makeRequest(url, 'GET');
};

// API function to get application documents
export const getApplicationDocuments = async (
  appl_num: string,
  submission_num: string,
  submission_type: string
) => {
  const payload = {
    appl_num,
    submission_num,
    submission_type
  };
  return makeRequest('/peds-admin/get-application-docs', 'POST', payload);
};

// API function to get signed URL from s3_path
export const getSignedUrl = async (s3_path: string, center: string = 'peds') => {
  const payload = {
    s3_path,
    center
  };
  return makeRequest('/peds-admin/resource', 'POST', payload);
};

// API function to update peds record with changed fields
export const updatePedsRecord = async (payload: { id: number; fields: Record<string, any> }) => {
  return makeRequest('/peds-admin/update-record', 'POST', payload);
};

// API function to compare documents using draftable service
export const compareDocuments = async (payload: {
  child_object: string;
  parent_object: string;
}) => {
  return makeRequest('/peds-admin/compare-s3', 'POST', payload);
};
